import { render, staticRenderFns } from "./Citas.vue?vue&type=template&id=18e06a15&scoped=true&"
import script from "./Citas.vue?vue&type=script&lang=js&"
export * from "./Citas.vue?vue&type=script&lang=js&"
import style0 from "./Citas.vue?vue&type=style&index=0&id=18e06a15&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e06a15",
  null
  
)

export default component.exports